import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingService } from '../../loading/loading.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalController } from '@ionic/angular';
import { Subscription, finalize, take } from 'rxjs';
import { AlertComponent } from '../../alert/alert.component';
import { RoleService } from 'src/app/modules/services/role/roles.service';

@Component({
  selector: 'app-create-role-modal',
  templateUrl: './create-role-modal.component.html',
  styleUrls: ['./create-role-modal.component.scss'],
})
export class CreateRoleModalComponent {
  form: FormGroup;
  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private roleService: RoleService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {
    this.form = this.fb.group({
      roleName: ['', [Validators.required]],
      roleDescription: [''],
    });
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  onSubmit() {
    if (this.form.invalid) {
      return this.openSnackBar('Reveja os campos obrigatórios.', 'error');
    }
    this.loadingService.showLoading();

    const form = this.form.value;

    const formData = {
      nome: form.roleName,
      descricao: form.roleDescription,
    };

    return this.subscriptions.push(
      this.roleService
        .createRole(formData)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response: any) => {
            this.openSnackBar(response.message, 'sucess');
            return this.modalCtrl.dismiss(response, 'confirm');
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              return this.openSnackBar(erro.error.message, 'error');
            }
            if (erro.error.error == 'Unprocessable Entity') {
              return this.openSnackBar(erro.error.message, 'warning');
            } else {
              return this.openSnackBar(
                'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
                'error'
              );
            }
          }
        )
    );
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
